import { Input, Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { MAX_VIN_CODE_LENGTH } from '../../common/constants/vinCode';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';
import { useMedia } from '../../hooks/useMediaQuery';
import { primitiveColors, spacing } from '../../theming';

const VinCodeInput = ({ code, isLoading, onChange, onSubmit }) => {
    const { t } = useTranslation(['profile']);
    const { isExtraSmallDevice, isSmallDevice } = useMedia();

    // the same Check button sits beside the input, or under it on phones
    const checkButton = (
        <Button
            size="large"
            type="primary"
            onClick={() => onSubmit(code.toUpperCase())}
            className={`${classes['send_btn']} ${isLoading ? classes['button-disabled'] : ''}`}
            disabled={isLoading}
            loading={isLoading}
        >
            {t('profile:vin-code-btn')}
        </Button>
    );

    return (
        <div className={classes['input_wrapper']}>
            <Input
                style={{
                    height: isExtraSmallDevice ? '60px' : 'auto',
                    border: '1px solid #000',
                    borderRadius: '100px',
                    marginBottom: isExtraSmallDevice ? '16px' : '0',
                }}
                placeholder={t('profile:vin-code-placeholder')}
                showCount={{
                    formatter: ({ count }) =>
                        isExtraSmallDevice
                            ? `${count}/${MAX_VIN_CODE_LENGTH}`
                            : isSmallDevice
                              ? null
                              : `${t('profile:vin-code-characters')} ${count}/${MAX_VIN_CODE_LENGTH}`,
                }}
                value={code}
                onChange={e => {
                    if (e.target.value.length <= MAX_VIN_CODE_LENGTH) {
                        onChange(e);
                    }
                }}
                addonAfter={
                    isExtraSmallDevice ? null : <div className={classes['input_wrapper_addon']}>{checkButton}</div>
                }
            />

            {isSmallDevice && !isExtraSmallDevice && (
                <Typography.Text style={{ marginTop: spacing[1], display: 'block', color: primitiveColors.gray30 }}>
                    {`${t('profile:vin-code-characters')} ${code.length}/${MAX_VIN_CODE_LENGTH}`}
                </Typography.Text>
            )}

            {isExtraSmallDevice && <div className={classes['input_wrapper_addon_small_device']}>{checkButton}</div>}
        </div>
    );
};

VinCodeInput.propTypes = {
    code: PropTypes.string,
    error: PropTypes.string,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default VinCodeInput;
